import React, { useEffect, lazy, Suspense } from "react";
import { useRouteMatch, Switch, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import * as Sentry from "@sentry/react";

import { actions as userActions } from "store/users";
import { selectUserUid } from "store/users/selectors";

import { PrivateRoute } from "utils/routes";

import Loading from "components/Loading";
import ErrorFallback from "components/ErrorFallback";

const ParametricAnalysisPage = lazy(() => import("./ParametricAnalysisPage"));
const ParametricAnalysisDashboard = lazy(() => import("features/Dashboards/ParametricAnalysisDashboard"));
const CreateParametricAnalysis = lazy(() => import("./CreateParametricAnalysis"));

const { fetchParametricDir } = userActions;

const ParametricAnalysis = ({ userUid, fetchParametricDir }) => {
    const { path } = useRouteMatch();

    useEffect(() => {
        if (!userUid) return;

        fetchParametricDir(userUid);
    }, [fetchParametricDir, userUid]);

    return (
        <Sentry.ErrorBoundary fallback={<ErrorFallback fallbackAction={() => {}} />}>
            <Suspense fallback={<Loading />}>
                <Switch>
                    <PrivateRoute path={`${path}/dashboard`} component={ParametricAnalysisDashboard} />
                    <PrivateRoute path={`${path}/analysis/:analysisId`} component={ParametricAnalysisPage} />
                    <PrivateRoute path={`${path}/create`} component={CreateParametricAnalysis} />
                    <Redirect to="/404-page-not-found" />
                </Switch>
            </Suspense>
        </Sentry.ErrorBoundary>
    );
};

const mapStateToProps = createStructuredSelector({
    userUid: selectUserUid,
});

const mapDispatchToProps = (dispatch) => ({
    fetchParametricDir: (uid) => dispatch(fetchParametricDir(uid)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ParametricAnalysis);
